import React, { useState } from 'react';
import { useFormik } from 'formik';
import { Col, Row } from 'react-bootstrap';
import Loader from '../Loader/Loader';
import { postBanks } from '../../apiservices/ApiServices';

const BankInfo = (props) => {
    const [isLoadings, setLoadings] = useState(false);

    const initialValues = {
        orgId: props.orgId || '',
        id: props.editBank?.bank_account_id || '',
        bankName: props.editBank?.bank_name || '',
        BranchName: props.editBank?.bank_branch_name || '',
        accountNumber: props.editBank?.account_number || '',
        beneficiaryName: props.editBank?.beneficiary_name || '',
        ifscCode: props.editBank?.bank_ifsc_code || '',
        micrCode: props.editBank?.bank_micr_code || '',
        swiftcode: props.editBank?.bank_swift_code || '',
        accountTypeCode: props.editBank?.account_type_code || '',
    }

    const { values, errors, touched, handleBlur, setFieldValue, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);
            let postData = {
                org_id: values.orgId,
                bank_account_id: values.id,
                bank_name: values.bankName,
                bank_branch_name: values.BranchName,
                account_number: values.accountNumber,
                beneficiary_name: values.beneficiaryName,
                bank_ifsc_code: values.ifscCode,
                bank_micr_code: values.micrCode,
                bank_swift_code: values.swiftcode,
                account_type_code: values.accountTypeCode,
            }
            try {
                const res = await postBanks(postData);
                props.toast.success(res.data.message);
                props.setAddBank(false)
                setLoadings(false);
                props.postUpdateOrganizationProfiles();

            } catch (error) {
                setLoadings(false);
                props.toast.error(error.response?.data?.message || "Error submitting data");
            }

        }
    })
    return (
        <>
            <div className='fieldsets cols_5'>
                <div className='fieldsets-title'>Add Bank</div>
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Bank Name</label>
                                <input
                                    type='text'
                                    id="bankName"
                                    name="bankName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.bankName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.bankName && touched.bankName && (
                                    <p className="errormsg">{errors.bankName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Branch Name</label>
                                <input
                                    type='text'
                                    id="BranchName"
                                    name="BranchName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.BranchName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.BranchName && touched.BranchName && (
                                    <p className="errormsg">{errors.BranchName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Account Number</label>
                                <input
                                    type='text'
                                    id="accountNumber"
                                    name="accountNumber"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.accountNumber}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.accountNumber && touched.accountNumber && (
                                    <p className="errormsg">{errors.accountNumber}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Beneficiary Name</label>
                                <input
                                    type='text'
                                    id="beneficiaryName"
                                    name="beneficiaryName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.beneficiaryName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.beneficiaryName && touched.beneficiaryName && (
                                    <p className="errormsg">{errors.beneficiaryName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">IFSC Code</label>
                                <input
                                    type='text'
                                    id="ifscCode"
                                    name="ifscCode"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.ifscCode}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.ifscCode && touched.ifscCode && (
                                    <p className="errormsg">{errors.ifscCode}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">MICR Code</label>
                                <input
                                    type='text'
                                    id="micrCode"
                                    name="micrCode"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.micrCode}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.micrCode && touched.micrCode && (
                                    <p className="errormsg">{errors.micrCode}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Swift Code</label>
                                <input
                                    type='text'
                                    id="swiftcode"
                                    name="swiftcode"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.swiftcode}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.swiftcode && touched.swiftcode && (
                                    <p className="errormsg">{errors.swiftcode}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Account Type Code</label>
                                <input
                                    type='text'
                                    id="accountTypeCode"
                                    name="accountTypeCode"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.accountTypeCode}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.accountTypeCode && touched.accountTypeCode && (
                                    <p className="errormsg">{errors.accountTypeCode}</p>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>{props.editBank?.bank_account_id ? 'Update' : 'Save'}</button>
                            <button type='button' onClick={() => { props.setAddBank(false); props.setEditBank(null); }} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    )
}

export default BankInfo